import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthorizationService } from '../../../../services/authorization.service';
import { ConfigService } from '../../../../services/config.service';
import { OrderService } from '../../../../services/order.service';
import { ContactService } from '../../../../services/contact.service';

@Component({
  selector: 'app-quote-cfd-pdf',
  templateUrl: './quote-cfd-pdf.component.html',
  styleUrls: ['./quote-cfd-pdf.component.css']
})

export class QuoteCfdPdfComponent implements OnInit {
  private readonly _configService: ConfigService;
  private readonly _contactService: ContactService;
 // disclaimerType = ''
  configIsReadySubscription!: Subscription;
  contentSolutionsClientManagerName = '';
  contentSolutionsClientManagerPhone = '';
  contentSolutionsClientManagerEmail = '';
  contentSolutionsClientManagerFax = '';
  @Input() enteredByUserRole : string | null = null;
  @Input() disclaimerType : string | null = null;

  constructor(public orderService: OrderService, configService: ConfigService, contactService: ContactService, private authorizationService: AuthorizationService) {
    this._configService = configService;
    this._contactService = contactService;
  }

  ngOnInit(): void {
    if (this.orderService.orderDto.billToDto.isPORequired) {
      this.disclaimerType = 'porequired';
    } else if (this.orderService.orderDto.billToDto.creditLimit !== 10000 && this.orderService.orderDto.billToDto.creditLimit !== 1000) {
      this.disclaimerType = 'prepayrequired';
    } else {
      this.disclaimerType = 'standard';
    }
    
    this.getClientManagerName();
  }

  generateFullName(firstName: string | null, lastName: string | null): string {
    return [firstName, lastName].filter(Boolean).join(' ');
  }
 generateBillToName(): string {
    if (this.orderService.orderDto.paymentMethod === 'S') {
      return this.generateFullName(this.orderService.orderDto.shipToDto?.firstName ?? null, this.orderService.orderDto.shipToDto?.lastName ?? null);
    }
    if(this.orderService.orderDto.billToDto.contactId !== null){
      let billToContact = this._contactService.contactDtos?.find(c => c.contactId === this.orderService.orderDto.billToDto.contactId);
      if(billToContact){
        return this.generateFullName(billToContact.firstName ?? null, billToContact.lastName ?? null);
      }
    }
    return this.generateFullName(this.orderService.orderDto.orderByDto?.firstName ?? null, this.orderService.orderDto.orderByDto?.lastName ?? null);
  }
  generateCityStateZipForBillTo(city: string | null, state: string | null | undefined, zip: string | null): string {
    if(this.orderService.orderDto?.paymentMethod === 'S'){
      zip = this.orderService?.selectedShipToContact?.mailingStreet ? this.orderService.selectedShipToContact?.mailingZip
        : this.orderService?.selectedShipToContact?.street ? this.orderService.selectedShipToContact?.zip
          : this.orderService.orderDto?.shipToDto?.zip;
      state = this.orderService?.selectedShipToContact?.mailingStreet ? this.orderService?.selectedShipToContact?.mailingState
        : this.orderService?.selectedShipToContact?.street ? this.orderService?.selectedShipToContact?.state
          : this.orderService.orderDto?.shipToDto?.state;
      city = this.getCityDetailsForBillTo();
    }
    
    return [[city, state].filter(Boolean).join(', '), zip].filter(Boolean).join(' ');
  }
  getCityDetailsForBillTo() {
    return this.orderService?.selectedShipToContact?.mailingStreet ? this.orderService.selectedShipToContact?.mailingCity
      : this.orderService?.selectedShipToContact?.street ? this.orderService.selectedShipToContact?.city
        : this.orderService.orderDto?.shipToDto?.city;
  }
  generateCityStateZipForShipTo(city: string | null, state: string | null | undefined, zip: string | null): string {
    if(this.orderService.orderDto?.paymentMethod === 'S'){
      zip = this.orderService?.selectedShipToContact?.street ? this.orderService.selectedShipToContact?.zip
        : this.orderService?.selectedShipToContact?.mailingStreet ? this.orderService.selectedShipToContact?.mailingZip
        : this.orderService.orderDto.billToDto?.street ? this.orderService.orderDto.billToDto?.zip
        : this.orderService.orderDto?.shipToDto?.zip;
      state = this.orderService?.selectedShipToContact?.street ? this.orderService?.selectedShipToContact?.state
        : this.orderService?.selectedShipToContact?.mailingStreet ? this.orderService?.selectedShipToContact?.mailingState
        : this.orderService.orderDto.billToDto?.street ? this.orderService.orderDto.billToDto?.state
        : this.orderService.orderDto?.shipToDto?.state;
      city = this.getCityDetailsForShipTo();
    }

    return [[city, state].filter(Boolean).join(', '), zip].filter(Boolean).join(' ');
  }
  getCityDetailsForShipTo(){
    return this.orderService?.selectedShipToContact?.street ? this.orderService?.selectedShipToContact?.city
        : this.orderService?.selectedShipToContact?.mailingStreet ? this.orderService?.selectedShipToContact?.mailingCity
        : this.orderService.orderDto.billToDto?.street ? this.orderService.orderDto.billToDto?.city
        : this.orderService.orderDto?.shipToDto?.city;
  }
  
  getNonTaxableSubTotal(): number {
    return this.orderService.orderDto.orderDetailDtos.filter(o => o.taxAmount === 0).map(o => o.extendedPrice).reduce((a, b) => a + b, 0);
  }

  getTaxableSubtotal(): number {
    return this.orderService.orderDto.orderDetailDtos.filter(o => o.taxAmount > 0).map(o => o.extendedPrice).reduce((a, b) => a + b, 0);
  }

  getEstimatedTax(): number {
    return this.orderService.orderDto.orderDetailDtos.map(o => o.taxAmount).reduce((a, b) => a + b, 0);
  }

  getEstimatedAmountDue(): number {
    const nonTaxableSubTotal = this.getNonTaxableSubTotal();
    const taxableSubTotal = this.getTaxableSubtotal();
    const estimatedTax = this.getEstimatedTax();
    return nonTaxableSubTotal + taxableSubTotal + estimatedTax;
  }
  getClientManagerName(): string {
    if (this.orderService.orderDto.salesOrganization === 'Shutterfly') {
      if (this.orderService.orderDto.billToDto.accountTypeCode === 'O') {
          this.contentSolutionsClientManagerEmail = this._configService.getEmailFromCustomerService('O');
          this.contentSolutionsClientManagerPhone = this._configService.getPhoneFromCustomerService('O');
          this.contentSolutionsClientManagerFax = this._configService.getFaxFromCustomerService('O');
          return this._configService.hasResource('OverrideSmallAccountClientManagerName')  ? "Melissa Werth" : this._configService.user.fullName;
      }
      else {
        return this.orderService.orderDto.billToDto.printRepCode? this.getClientManagerInfo(this.orderService.orderDto.billToDto.printRepCode): '';
      }   
    }
    return this.getClientManagerInfo(this.orderService.orderDto.billToDto.accountOwnerCode);
  }
  getClientManagerInfo(userCode: string): string {
    this.contentSolutionsClientManagerEmail = this._configService.getUserEmailFromUserCode(userCode);
    this.contentSolutionsClientManagerPhone = this._configService.getUserPhoneFromUserCode(userCode);
    this.contentSolutionsClientManagerFax = this._configService.getFaxFromSalesforce(userCode);
    return this._configService.getFullNameFromUserCode(userCode); 
  }
}
